export default __webpack_public_path__ + "static/media/le_lion.0eae418c.jpg";